/* eslint-disable react/prop-types */
/** @jsx createElement */
// noinspection ES6UnusedImports
import { createElement } from '../../jsx';
import styles from './styles.less';

const TransferUploadButton = function ({ onChange, label, className }) {
  const triggerChild = (e) => {
    if (e.target === e.currentTarget
      && (!e.code || ['Space', 'Enter'].includes(e.code))) {
      e.currentTarget.querySelector('label').click();
      e.currentTarget.blur();
    }
  };
  return (
    <div
      tabIndex="0"
      role="button"
      className={`${className} ${styles.chatTransferUploadBtn}`}
      onKeyDown={triggerChild}
      onClick={triggerChild}
    >
      <label
        htmlFor="TransferUploadFile"
        className={styles.chatTransferUploadLbl}
      >
        <input
          id="TransferUploadFile"
          type="file"
          accept="image/*,.pdf"
          style={{ display: 'none' }}
          onChange={onChange}
          multiple
        />
        <span>{label}</span>
      </label>
    </div>
  );
};

export default TransferUploadButton;
